import React, {useEffect, useRef, useState} from 'react';
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {connect, useSelector} from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {moduleService} from "../../../jwt/_services";
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setDataToEdit, setEditMode, setEnabledForm, setFormInfo} from "../../../redux/actions/genericActions";
import {
    FL_CATEGORY,
    FL_CODE,
    FL_DESCRIPTION,
    FL_ICON,
    FL_NAME,
    FL_STATUS
} from "../../../components/i18n/formLabels";
import {PH_CODE, PH_DESCRIPTION, PH_NAME} from "../../../components/i18n/placeHolders";
import SelectGeneric from "../../../components/select/selectGeneric";
import {moduleResourcesProvider} from "../../../providers/resourcesProvider";
import {cons} from "../../../assets/react-css/const";
import ModuleUdnSection from "./udnSection/UdnSection";
import ModuleMenuSection from "./menuSection/MenuSection";

// components

// labels


// actions

// providers

// utils

// services

const ModuleControllerForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { editMode, domainObject, category } = componentState?.data;


    const [status, setStatus] = useState(domainObject?.enabled || true);
    const [categoryModule] = useState( domainObject?.categoryModule || category || null );
    const [moduleIcon, setModuleIcon] = useState(null);
    const [iconImage, setIconImage] = useState( null);

    const [showModal, setShowModal] = useState(false)
    const modalRef = useRef(null);

    useEffect(() => {
        if (domainObject?.id !== undefined) {
            setIconView(domainObject?.icon);
        }
    }, [domainObject]);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            description: domainObject?.description,
            showOrder: domainObject?.showOrder,
            code: domainObject?.code,
            icon: domainObject?.icon,
            enabled: domainObject?.enabled
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
            icon: moduleIcon,
            enabled: status,
        }

        if (!editMode) {
            // console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, moduleService, dataRequest)
        }

        else {
            let id = domainObject.id;
            dataRequest.id = domainObject?.id
            // console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, moduleService, id, dataRequest)
        }

        closeForm()
    };

    const setIconView = (value) => {
        let img;
        try {
            img = require("../../../assets/images/icon/modules/" + value);
        } catch (e) {
            img = null;
        }

        setModuleIcon(value);
        setIconImage(img);
    }

    const closeForm = () => props.onClose()

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={ 'card-modal-medium-ex' }>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <img style={cons.iconStyle} src={iconImage} alt={'image'}/>
                    <h2 className={'card-modal-title'}> {(domainObject?.title || domainObject?.name || '')}</h2>
                    <br/>
                </>
                <div className={'top-right'}>
                <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericButton
                                style={'table'}
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label >{ FL_CODE + " : [APP]_[MODULO]_[UDN] " }</Label>
                            <Input type="name" name="code"
                                   placeholder={ PH_CODE }
                                   innerRef={register}
                                   className={(errors.code ? ' is-invalid' : '')}
                            />
                            <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback" />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label >{ FL_NAME }</Label>
                            <Input type="text"
                                   name="name"
                                   placeholder={ PH_NAME }
                                   innerRef={register}
                                   className={(errors.name ? ' is-invalid' : '')}
                            />
                            <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback" />
                        </FormGroup>
                    </Col>

                    <Col md="2">
                        <FormGroup>
                            <Label >{ FL_CATEGORY }</Label>
                            <Input type="text"
                                   disabled={true}
                                   value={ categoryModule?.name || '' }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_ICON }</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={ moduleIcon }
                                setExternalValue={ setIconView }
                                provider={ moduleResourcesProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label >{ FL_STATUS }</Label><br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                                    value={status}/>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >{ FL_DESCRIPTION }</Label>
                            <Input type="textarea"
                                   name="description"
                                   rows="2"
                                   placeholder={ PH_DESCRIPTION }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="6">
                        { domainObject?.id &&  <ModuleUdnSection path={path}/> }
                    </Col>
                    <Col md="6">
                        { domainObject?.id &&  <ModuleMenuSection path={path}/> }
                    </Col>
                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFormInfo,
    setDataToEdit,
    setEnabledForm,
    setEditMode
})

export default connect(mapStateToProps, mapActionsToProps)(ModuleControllerForm)